import React, { Fragment } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import _ from 'lodash';
import veracodeLogo from '~/images/sca-veracode-logo-white.png';
import { SOURCECLEAR_COMPONENTS } from '~/constants/ModelConstants';
import AnnouncementBanner from '~/components/AnnouncementBanner';
import config from '~/config';
const LoggedOutHeader: React.SFC<{}> = () => {
  // depending on which domain they are on, the login link should take them to the correct login page
  const isVeracodeDomain = _.includes(config.VERACODE_DOMAINS, window.location.hostname);
  const headerData = isVeracodeDomain
    ? { wwwUrl: config.VC_WWW_URL, loginUrl: config.VERACODE_LOGIN_HOST }
    : { wwwUrl: config.WWW_URL, loginUrl: `${config.APP_URL}/login` };

  const registryLinkClasses = classNames('btn btn--nav-default font--14', {
    'sc-link-font': !isVeracodeDomain,
  });
  return (
    <Fragment>
      <section className="logged-out container--full bg-color--black-dark zIndex-7--nav">
        <section className="container flex flex--align-items--center phone--flex--flex-direction--column phone--no-center overflow--hidden">
          <div className="col-2-10 phone--col-1-1 pb-- flex flex--align-items--center height--78">
            <a className="link--plain link--no-underline phone--col-9-10" href={headerData.wwwUrl}>
              <img src={veracodeLogo} className="vc-logo" />
            </a>

            <a className="toggle text--right desk--hide phone--col-1-10">
              <i className="fa fa-bars color--white font--20" />
            </a>
          </div>
          <div className="col-8-10 phone--col-1-1 flex flex--justify-content--end flex--align-items--center phone--flex--flex-direction--column phone--pb top--nav">
            <li className="color--black-dark navbar__item">
              <Link
                className={registryLinkClasses}
                to={`${config.VC_WWW_URL}/products/software-composition-analysis`}
                target="_blank"
              >
                Software Composition Analysis
              </Link>
            </li>
            <li className="color--black-dark navbar__item">
              <Link
                className={`${registryLinkClasses} active`}
                to={`/${SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug}/search`}
              >
                {SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.name.toUpperCase()}
              </Link>
            </li>
            <li className="color--black-dark navbar__item color--white">
              <span className="font--14 sc-link-font">|</span>
            </li>
            <li className="color--black-dark navbar__item">
              <a className={registryLinkClasses} href={headerData.loginUrl}>
                LOGIN
              </a>
            </li>
          </div>
        </section>
      </section>
    </Fragment>
  );
};
export default LoggedOutHeader;
